
const pageTextConfig = {
    pageTitle: "Complete the process",
    warning: {
        title: "IMPORTANT",
        description: "We never ask for any OTP or any other sensitive bank related information over phone."
    },

    termsAndConditions: [
        "I acknowledge that by checking this box, I agree to uphold the highest standards of professional ethics and conduct while freelancing on this platform. ",
        "I understand that this includes, but is not limited to, maintaining a high level of professionalism in all client interactions, delivering quality work on time, and adhering to the guidelines and policies set forth by the platform. ",
        "I also understand that any violation of these standards may result in disciplinary action, up to and including termination of my account. ",
        "By agreeing to these terms, I am committing to being a responsible, reliable, and trustworthy member of the freelancing community on this platform."
    ]

}

export default pageTextConfig